import { combineReducers } from '@reduxjs/toolkit';

// Feature scoped APIs
import { appointmentsApi } from '../actions/appointments';
import { bulkAssigneesApi } from '../actions/appointments/bulkAssignees';
import { conflictsApi } from '../actions/appointments/conflicts';
import { missingQualificationsApi } from '../actions/appointments/missingQualifications';
import { rejectedApi } from '../actions/appointments/rejected';
import { unallocatedApi } from '../actions/appointments/unallocated';
import { awardAlertsApi } from '../actions/awardAlerts';
import { clientsApi } from '../actions/clients';
import { publishApi } from '../actions/index';
import { usersApi } from '../actions/users';
import { usersRunningLateApi } from '../actions/users/runningLate';
import { visualiseApi } from '../actions/visualise';
// Reducers
import * as appointmentsReducers from './appointments';
import awardAlerts from './awardAlerts';
import * as clientsReducers from './clients';
import unsaved from './unsaved';
import * as usersReducers from './users';
import runningLate from './users/runningLate';
import visualise from './visualise';
import weeklyPlannerReducer from './weeklyPlanner';

export const weeklyPlanner = {
  ...appointmentsReducers,
  ...clientsReducers,
  ...usersReducers,
  weeklyPlanner: weeklyPlannerReducer,
  awardAlerts,
  runningLate,
  unsaved,
  visualise,
};

export default combineReducers(weeklyPlanner);

// Export feature-scoped APIs array
export const weeklyPlannerApis = [
  appointmentsApi,
  awardAlertsApi,
  bulkAssigneesApi,
  clientsApi,
  conflictsApi,
  missingQualificationsApi,
  publishApi,
  rejectedApi,
  usersApi,
  usersRunningLateApi,
  unallocatedApi,
  visualiseApi,
] as const;
